import script from "./order-of-payment.vue?vue&type=script&setup=true&lang=js"
export * from "./order-of-payment.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__